var path = 'app/components/common/breadcrumb/breadcrumb.html';
var html = "<div id=\"hbreadcrumb\" class=\"m-t-lg\"><ol class=\"hbreadcrumb breadcrumb\"><li ng-repeat=\"state in vm.states\" ng-switch=\"$last\" ng-class=\"{active: $last}\"><a ng-switch-when=\"false\" href=\"#{{state.url.format(vm.stateParams)}}\">{{state.data.pageTitle}}</a> <span ng-switch-when=\"true\">{{state.data.pageTitle}}</span></li></ol></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/components/common/breadcrumb/breadcrumb.html
// module id = 451
// module chunks = 0